<template>
    <div id="LightBoxLog">
        <HrrBreadcrumb PMname="其他功能" CMname="媒体日志" />
        <div class="main">
            <el-row :gutter="15">
                <el-col :span="4">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            站点媒体信息（站点-->媒体）
                        </div>
                        <el-scrollbar class="ll-infinite-list">
                            <el-tree highlight-current :data="treeData" :props="defaultProps" node-key="id" :default-expand-all="defaultexpandall" ref="Tree" v-loading="treeloading" @node-click="nodeclick" auto-expand-parent :default-expanded-keys="defaultexpandedkeys">
                            </el-tree>
                        </el-scrollbar>
                    </el-card>
                </el-col>
                <el-col :span="20">
                    <el-row>
                        <el-col>
                            <el-card class="box-card">
                                <el-form :inline="true" :model="searchform">
                                    <el-form-item>
                                        <el-button type="primary" @click="PrevDateClick">上一日</el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-date-picker :editable="false" :clearable="false" v-model="searchform.date" placeholder="查看时间" @change="changetime" value-format="yyyy-MM-dd" type="date"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="NexDateClick">下一日</el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="warning" @click="RefreshClick">刷新</el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="info" @click="returnClick" v-if="isShowReturn">返回</el-button>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15">
                        <el-col :span="6">
                            <el-card class="box-card my-el-card">
                                <div slot="header" class="clearfix">
                                    当日工作时长
                                </div>
                                <ve-gauge :data="WorkTimeData" height="320px" :settings="worktimechartSettings" :data-empty="gaugenodata"></ve-gauge>
                            </el-card>
                        </el-col>
                        <el-col :span="18">
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    电流&亮度信息
                                </div>
                                <ve-line :data="linechartData" :loading="loading" :extend="extend" :after-config="afterconfig" :data-zoom="chartDataZoom" :data-empty="linenodata" :settings="chartSettings" height="280px"></ve-line>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15">
                        <el-col :span="8">
                            <el-card class="box-card scard">
                                <div slot="header" class="clearfix">
                                    指令发送
                                </div>
                                <el-scrollbar class="infinite-list">
                                    <el-card class="el-card-dashed" v-for="item in ordersData">
                                        <el-row>
                                            <el-col :span="12"><a>指令类型：</a>{{item.orderType}}</el-col>
                                            <el-col :span="12"></el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12"><a>创建时间：</a>{{item.creationDate}}</el-col>
                                            <el-col :span="12"><a>创建人：</a>{{item.creationBy}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12"><a>审批时间：</a>{{item.approveDate}}</el-col>
                                            <el-col :span="12"><a>审批人：</a>{{item.approveBy}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12"><a>发送时间：</a>{{item.sendDate}}</el-col>
                                            <el-col :span="12"><a>发送人：</a>{{item.sendBy}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24"><a>指令内容：</a>
                                                <span v-if="item.orderType!='调光'">{{item.contentCN}}</span>
                                                <ul v-if="item.orderType=='调光'">
                                                    <li v-for="o in item.LightOrders">{{o}}</li>
                                                </ul>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-scrollbar>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card class="box-card scard">
                                <div slot="header" class="clearfix">
                                    异常信息
                                </div>
                                <el-scrollbar class="infinite-list">
                                    <el-card class="el-card-dashed" v-for="item in alertsData">
                                        <el-row>
                                            <el-col :span="12"><a>报警名称：</a>{{item.alertName}}</el-col>
                                            <el-col :span="12"><a>报警时间：</a>{{item.alertTime}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12"><a>报警类型：</a>{{item.alertType}}</el-col>
                                            <el-col :span="12"><a>流路类型：</a>{{item.mtypeName}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12"><a>报警条件：</a>{{'当'+item.mtypeName+item.alertCondition+item.alertValue+'('+item.valueType+')'}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12"><a>发送标题：</a>{{item.sendTitle}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24"><a>发送模板：</a>{{item.sendTemplate}}
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-scrollbar>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card class="box-card scard">
                                <div slot="header" class="clearfix">
                                    检测信息
                                </div>
                                <el-scrollbar class="infinite-list">
                                    <el-card class="el-card-dashed" v-for="item in checkupData">
                                        <el-row>
                                            <el-col :span="12"><a>检查时间：</a>{{item.inspectionDate}}</el-col>
                                            <el-col :span="12"><a>是否异常：</a>{{item.Is_Abnormal==1?'有异常':'无异常'}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24"><a>检查人：</a>{{item.usersName}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24"><a>检查内容：</a>{{item.checkupContect}}</el-col>
                                        </el-row>
                                    </el-card>
                                </el-scrollbar>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name: 'site_info',
    data() {
        this.extend = {
            yAxis: {
                axisLabel: {
                    color: "#fff"
                },
                nameTextStyle: {
                    color: "#fff"
                }
            },
            xAxis: {
                axisLabel: {
                    color: "#fff"
                }
            },
            series: {
                type: 'line',
                label: {
                    color: "rgba(181, 32, 32, 1)"
                }

            },
            legend: {
                textStyle: {
                    color: "#e6a23c"
                }
            },
            tooltip: {
                formatter: function(params, ticket, callback) {
                    var res = params[0].name;
                    for (var i = 0; i < params.length; i++) {
                        res += "<br>" + params[i].marker + params[i].seriesName + "：" + (params[i].data[1] == null ? "0" : params[i].data[1]);
                    }
                    return res;
                }
            }
        };
        this.chartDataZoom = [{
            type: 'slider',
            textStyle: {
                color: "#fff"
            }
        }];
        this.chartSettings = {
            axisSite: { right: ['亮度'] },
            yAxisName: ['', '亮度(%)'],
        }
        this.worktimechartSettings = {
            dataName: {
                '工作时间': '小时'
            },
            seriesMap: {
                '工作时间': {
                    min: 0,
                    max: 24,
                    title: {
                        textStyle: {
                            fontWeight: 'bolder',
                            fontSize: 18,
                            fontStyle: 'italic',
                            color: '#fff',
                            shadowColor: '#fff',
                            shadowBlur: 10
                        }
                    }
                }
            }
        }
        return {
            searchform: {
                date: "",
                deviceCode: "",
            },
            linechartData: {
                columns: ['日期', '电流1', '电流2', '电流3', '亮度'],
                rows: [
                    { '日期': new Date(), '电流1': 0, '电流2': 0, '电流3': 0, '亮度': 0 }
                ]
            },
            WorkTimeData: {
                columns: ['type', 'value'],
                rows: [
                    { type: '工作时间', value: 0 }
                ]
            },
            ordersData: [],
            alertsData: [],
            checkupData: [],
            defaultexpandall: false,
            tab: "report",
            treeData: [],
            defaultProps: {
                children: 'childList',
                label: 'name'
            },
            treeloading: true,
            loading: true,
            linenodata: false,
            gaugenodata: false,
            defaultexpandedkeys: [],
            isShowReturn: false,
            returnPath: "",
        }
    },
    methods: {
        PrevDateClick() {
            let cdate = new Date(this.searchform.date);
            this.searchform.date = new Date(cdate.setDate(cdate.getDate() - 1));
            this.initData();
        },
        NexDateClick() {
            let cdate = new Date(this.searchform.date);
            this.searchform.date = new Date(cdate.setDate(cdate.getDate() + 1));
            this.initData();
        },
        RefreshClick() {
            this.initData();
        },
        afterconfig(options) {
            return options;
        },
        getNFDay(nowDate) {
            var char = "-";
            var completeDate = function(value) {
                return value < 10 ? "0" + value : value;
            }
            if (nowDate == null) {
                nowDate = new Date();
            }
            var day = nowDate.getDate();
            var month = nowDate.getMonth() + 1; //注意月份需要+1
            var year = nowDate.getFullYear();
            //补全0，并拼接
            return year + char + completeDate(month) + char + completeDate(day);
        },
        nodeclick(data, node, o) {
            if (!data.childList) {
                this.searchform.deviceCode = data.id;
                this.initData();
            }
        },
        returnClick() {
            this.$router.push({ path: this.returnPath });
        },
        changetime() {
            this.initData();
        },
        Rowdelete(val) {
            this.$confirm("确定要删除 '" + val.siteName + "' 此记录么？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios({
                            method: "delete",
                            url: this.$api.site.DelSite + "/" + val.siteId
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.searchform.date = this.getNFDay(new Date(this.searchform.date));
            if (this.searchform.deviceCode != "") {
                this.$hrraxios.get(this.$api.Log.api, { params: this.searchform })
                    .then(function(response) {
                        Vuethis.loading = false;
                        var data = response.data;
                        if (data.Success == true) {
                            Vuethis.linenodata = (data.Data.electricityChartData.rows.length == 0) ? true : false;
                            Vuethis.gaugenodata = (data.Data.workTimeChartData.rows[0] == null) ? true : false;
                            Vuethis.WorkTimeData.rows[0].value = Vuethis.gaugenodata ? 0 : data.Data.workTimeChartData.rows[0].value;
                            Vuethis.linechartData = data.Data.electricityChartData;
                            Vuethis.ordersData = data.Data.orders;
                            Vuethis.alertsData = data.Data.alerts;
                            Vuethis.checkupData = data.Data.checkUps;
                        } else {
                            Vuethis.$message.error(data.Prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.loading = false;
                        console.log(error);
                    });
            } else {
                this.linenodata = true;
                this.gaugenodata = true;
                this.loading = false;
            }
        },
        initTree() {
            var Vuethis = this;
            this.treeloading = true;
            this.$hrraxios.get(this.$api.lightbox.tree)
                .then(function(response) {
                    Vuethis.treeloading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.treeData = data.Data;
                        if (Vuethis.$route.params.devicecode) {
                            setTimeout(() => {
                                Vuethis.$refs.Tree.setCurrentKey(Vuethis.searchform.deviceCode);
                            }, 500);
                        }
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.treeloading = false;
                    console.log(error);
                });
        },
        initParamsData() {
            if (this.$route.params.devicecode) {
                this.searchform.deviceCode = this.$route.params.devicecode;
                this.defaultexpandedkeys.push(this.$route.params.devicecode);
                this.isShowReturn = true;
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.returnPath = from.path;
        })
    },
    created() {
        let Now = new Date();
        this.searchform.date = Now.toLocaleDateString();
        this.$common.getFunListByMCode(this, "LightBoxLog", () => {
            this.initTree();
            this.initParamsData();
            this.initData();
        });
    }
};
</script>
<style>
#LightBoxLog .main {
    padding: 15px;
}

#LightBoxLog .el-row {
    margin-bottom: 15px;

    &:last-child {
        margin-bottom: 0;
    }
}

#LightBoxLog .my-el-card .el-card__body {
    padding: 0px;
}

#LightBoxLog .el-form-item {
    margin-bottom: 0px;
}

#LightBoxLog .el-form-item {}

.customreport-el-tabs {
    margin: 15px;
}

#customreport .el-form-item {
    margin-bottom: 0px;
}

.v-charts-data-empty {
    background-color: rgba(30, 63, 108, .9) !important;
    color: #c4c7cd !important;
    font-size: 16px !important;
}

.v-charts-component-loading {
    background-color: rgba(152, 232, 255, .1) !important
}

.v-charts-component-loading .path {
    stroke-width: 4px !important;
}

#LightBoxLog .scard .el-row {
    margin: 4px 0;
    font-size: 12px !important;
}

#LightBoxLog .el-card-dashed {
    border: 1px dashed #98e8ff;
    margin-bottom: 10px;
}

#LightBoxLog .el-card-dashed .el-card__body {
    padding: 10px;
}

#LightBoxLog .el-card-dashed a {
    color: #98e8ff;
}

.infinite-list {
    height: 280px;
}

.infinite-list ul {
    position: relative;
    left: 60px;
    top: -15px;
    list-style: none;
}
.ll-infinite-list{
    height: 772px;
}
</style>